import { subDays } from 'date-fns'

export const PREV_NEXT_BUTTONS_WIDTH = 28

/**
 * @deprecated This const should not be used directly. Use firstColumnStore instead
 */
export const FIRST_COLUMN_WIDTH = {
  DESKTOP: 310,
  MOBILE: 240,
  MOBILE_COLLAPSED: 90,
}

export const DAY_COLUMN_WIDTH = {
  DESKTOP: 38,
  DESKTOP_MAXIMISED: 54,
  MOBILE: 48,
}

export const TAPECHART_ROW_BASE_HEIGHT = {
  DESKTOP: 34,
  DESKTOP_MAXIMISED: 38,
  MOBILE: 36,
}

export const EXTENDED_COLUMN_GAP = 12

export const DEFAULT_VIEW_FROM_DATE = subDays(new Date(), 1)
export const TIME_FRAME_DAYS = 60

export const FILTERS_DATE_FORMAT = 'MMM d, yy'
export const ISO_DATE_FORMAT = 'yyyy-MM-dd'

export const TAPECHART_HEADER_ROW_HEIGHT = 30

export const UNKNOWN_REGION = 'unknown'

export const BOTTOM_BAR_HEIGHT = 60
